export default (cloudDisplay: string) => {
  return cloudDisplay.split(' - ');
};
